// The English / 中文 switch, in the top bar and on the login screen. It flips
// the whole app, and the choice is remembered in this browser (see lib/i18n).

import { useLang } from "../lib/i18n";

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <button
      type="button" // never submits the login form it sits in
      className="btn btn-ghost"
      onClick={() => setLang(lang === "zh" ? "en" : "zh")}
      title="Switch language / 切换语言"
    >
      {lang === "zh" ? "EN" : "中文"}
    </button>
  );
}
